export default __webpack_public_path__ + "static/media/Maintenance-art.8311a649.png";